var eventListing = {
    mapRetry:0,
    load:function(eventHash){
        this.eventHash = eventHash;
        this.eventGallery();
        this.eventDates();
        this.eventMap();
    },
    eventGallery:function(){
        new eventGallery("eventGallery");
    },
    eventDates:function(){
        var dateInput = document.getElementById("eventdates_"+this.eventHash);
        if(!dateInput) return;
        eventList.fromNow(dateInput.value,"fromNow_"+this.eventHash);
    },
    eventMap:function(){
        var mapElement = document.getElementById("eventMap_"+this.eventHash);
        if(!mapElement) return;
        if(typeof google === 'undefined'){
            if(this.mapRetry < 3){
                setTimeout(()=>{
                    this.mapRetry++;
                    this.eventMap();
                },2000);
            }
            return;
        }
        this.map = new google.maps.Map(mapElement, {
            center: { lat: parseFloat(mapElement.getAttribute("data-latitude")), lng: parseFloat(mapElement.getAttribute("data-longitude")) },
            zoom: 14,
            clickableIcons:false,

        });
        const icon = {
            url: ELAJAX.images + "mapIcon.png", // url
            scaledSize: new google.maps.Size(70, 70), // scaled size
            origin: new google.maps.Point(0,0), // origin
            anchor: new google.maps.Point(35, 70), // anchor
        };

        let marker = new google.maps.Marker({
            position:{ lat: parseFloat(mapElement.getAttribute("data-latitude")), lng: parseFloat(mapElement.getAttribute("data-longitude")) },
            label:'',
            icon:icon
        });
        marker.setMap(this.map);
        google.maps.event.addDomListener(marker, 'click', (e) => {
            window.open("https://maps.google.com/?q="+mapElement.getAttribute("data-address"));
        });
    }
};